exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tooltip-parent .tooltip-title[data-v-89be5c90] {\n  z-index: 20;\n}\n.text-media[data-v-89be5c90] {\n  height: 15vh;\n  overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-89be5c90","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/leads/LeadsFollowups.vue
// module id = +3Wy
// module chunks = 0